import SvgIcon from '@mui/material/SvgIcon';
import React from 'react';
import { ReactComponent as PinSvg } from './assets/pin.svg';

const PinIcon = React.forwardRef((args, ref) => <SvgIcon component={PinSvg} ref={ref} {...args} />);

export default PinIcon;
